import { IMAGES } from "@/config/site";

const PILLARS = [
  {
    title: "Health",
    image: IMAGES.pillarHealth,
    testid: "pillar-health-card",
    copy: "Grounding individuals in physical resilience, psychological sciences, and biomedical vitality led by professional athletics and wellness directors.",
  },
  {
    title: "Community",
    image: IMAGES.pillarCommunity,
    testid: "pillar-community-card",
    copy: "Building safe, well-informed neighborhoods through a self-sustaining barter and trade network that recycles dues into shared regional abundance.",
  },
  {
    title: "Edification",
    image: IMAGES.pillarEdification,
    testid: "pillar-edification-card",
    copy: "Comprehensive education in roles, debt capital markets, and institutional systems so members can navigate industry without friction.",
  },
];

const Pillars = () => {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="py-24 px-6 border-b border-stone-800 bg-stone-900/30"
    >
      <div className="max-w-7xl mx-auto space-y-16">
        <div className="max-w-2xl space-y-3">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">
            Triad Architecture
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-100 display-serif">
            Health, Community &amp; Edification
          </h2>
          <p className="text-stone-400 text-sm">
            Three interlocking disciplines cultivated to achieve personal vitality and economic
            sovereignty.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {PILLARS.map((pillar) => (
            <div
              key={pillar.title}
              data-testid={pillar.testid}
              className="rounded-xl border border-stone-800 bg-stone-950 p-6 space-y-4 relative overflow-hidden group hover:border-amber-600/50 transition-colors"
            >
              <div className="aspect-video rounded border border-stone-800 relative overflow-hidden">
                <img
                  src={pillar.image.url}
                  alt={pillar.image.alt}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-950/60 to-transparent pointer-events-none"></div>
              </div>
              <h3 className="text-xl font-bold text-stone-100">{pillar.title}</h3>
              <p className="text-xs text-stone-400 leading-relaxed">{pillar.copy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pillars;
